import {
	Asset,
	Link,
	Markdown,
	ResourceStatus,
	ResourceType,
} from "../../../index";

type ResourceConstructorProps = {
	internalId: string;
	externalId: string;
	name: string;
	shortDescription: Markdown;
	longDescription: Markdown;
	type: ResourceType;
	coverAsset: Asset;
	previewAssets: Asset[];
	docsUrl: string;
	providersIds: string[];
	status: ResourceStatus;
	links: Link[];
};

class Resource {
	internalId: string;
	externalId: string;
	name: string;
	shortDescription: Markdown;
	longDescription: Markdown;
	type: ResourceType;
	coverAsset: Asset;
	previewAssets: Asset[];
	docsUrl: string;
	providersIds: string[];
	status: ResourceStatus;
	links: Link[];

	constructor({
		internalId,
		externalId,
		name,
		shortDescription,
		longDescription,
		type,
		coverAsset,
		previewAssets,
		docsUrl,
		providersIds,
		status,
		links,
	}: ResourceConstructorProps) {
		this.internalId = internalId;
		this.externalId = externalId;
		this.name = name;
		this.shortDescription = shortDescription;
		this.longDescription = longDescription;
		this.type = type;
		this.coverAsset = coverAsset;
		this.previewAssets = previewAssets;
		this.docsUrl = docsUrl;
		this.providersIds = providersIds;
		this.status = status;
		this.links = links;
	}

	static fromJson(json: any) {
		return new Resource({
			internalId: json.internal_id,
			externalId: json.external_id,
			name: json.name || "",
			shortDescription: json.short_description,
			longDescription: json.long_description,
			type: json.type || ResourceType.defaultValue,
			coverAsset: json.cover_asset,
			previewAssets: json.preview_assets,
			docsUrl: json.docs_url,
			providersIds: json.providers_ids || [],
			status: json.status || ResourceStatus.INACTIVE,
			links: json.links || [],
		});
	}

	toJson = () => {
		return {
			internal_id: this.internalId,
			external_id: this.externalId,
			name: this.name,
			short_description: this.shortDescription,
			long_description: this.longDescription,
			type: this.type,
			cover_asset: this.coverAsset,
			preview_assets: this.previewAssets,
			docs_url: this.docsUrl,
			providers_ids: this.providersIds,
			status: this.status,
			links: this.links,
		};
	};
}

interface ResourcesCatalogProps {
	resources: Resource[];
}

class ResourcesCatalog {
	constructor(private _: ResourcesCatalogProps) {}

	get resources() {
		return this._.resources;
	}
}

export { Resource, ResourcesCatalog };
